import {
  EqualityFn,
  useSelector as useReduxSelector,
  useDispatch as useReduxDispatch,
  shallowEqual,
} from 'react-redux';

import { AppDispatch, RootState } from './store';

export const useSelector = <TState = RootState, Selected = unknown>(
  selector: (state: TState) => Selected,
  equalityFn?: EqualityFn<Selected> | undefined
) => useReduxSelector(selector, equalityFn ?? shallowEqual);

export const useDispatch = (): AppDispatch => useReduxDispatch();
